import { getURLParams } from "../Helpers/getURLParams";

export const getUTM = () => {

    // Obtener el valor de cada parámetro UTM
    let params_values = getURLParams(["utm_source", "utm_medium", "utm_campaign", "c", "id"])
    const utm_source = params_values.utm_source
    const utm_medium = params_values.utm_medium
    const utm_campaign = params_values.utm_campaign
    const c = params_values.c
    const id = params_values.id

    // 4. retorna los valores de los parámetros UTM
    let note_attributes = [
        {
            name:"utm_source",
            value: utm_source!==undefined? utm_source : null
        },
        {
            name:"utm_medium",
            value: utm_medium!==undefined? utm_medium : null
        },
        {
            name:"utm_campaign",
            value: utm_campaign!==undefined? utm_campaign : null
        },
        {
            name:"c",
            value: c !== undefined? c : null
        },
        {
            name:"id",
            value: id !== undefined? id : null
        },
    ]

    // console.log(note_attributes)

    return note_attributes // "note_attributes" is the array that uses easy form in shopify to save the UTM parameters
}